import React from 'react'
import EmployeeDashBoard from '../components/DashBoard/EmployeeDashBoard'
import EmployerDashBoard from '../components/DashBoard/EmployerDashBoard'
import { useSelector } from 'react-redux'
import { ACCOUNT_TYPE_MAPPINGS } from '../utils/constants'
const AdminDashboard = () => {
  const statisticDashBoardRoles =["admin"];
  const { authInfo} = useSelector(store => store.user);
  const {userInfo} = authInfo || {};
  const {AccountType} = userInfo || {};
  const showStatisticDashBoard = statisticDashBoardRoles.includes(ACCOUNT_TYPE_MAPPINGS[(AccountType||'').toUpperCase()]?.toLowerCase());
  return (
    <>
      {showStatisticDashBoard ? <EmployerDashBoard /> :<EmployeeDashBoard />}
    </>
  )
}
export {AdminDashboard}